
export const hash = '7de58dea-644f-4cc6-8411-2d911b66d819';
export const gateKey = '';
// export const gateKey = 'ek_test_chbrqNNodNGkGLSWF4fLxaATVFyhds';
export const recaptchaKey = '6LdKIrgZAAAAAFCgNLBhpQNO_a29D30zbLGQx9mb';
export const apiUrl = 'https://api-jornada-emergencias-pediatricas.encontrodigital.com.br';
export const apiSocket = 'https://socket.encontrodigital.com.br';
//export const apiSocket = 'http://localhost:8001';
//export const apiUrl = 'http://localhost:8000';
export const urlWebsite = 'https://jornada-emergencias-pediatricas.encontrodigital.com.br';

export const home = 'Home';
// export const urlWebsite = 'http://localhost:3000';
export const eventName = 'jornada-emergencias-pediatricas';
export const logo = '/assets/evento/capa/nome.png';
export const background = '/assets/evento/Fundo.jpeg';
export const authTitle = 'jornada-emergencias-pediatricas';
export const social = {
  whatsapp: '',
  instagram: '',
  facebook: '',
  linkedin: '',
  youtube: '',
  twitter: '',
};

export const defaultTheme = {
  defaultBackground: '#023B72',
  defaultColor: '#fff',
  logo: {
    minWidth: '450px',
  },
  menu: {
    background: 'none',
    backgroundSticky: '#fff',
    backgroundMobile: '#fff',
    color: '#023B72',
    shadow: '0',
    logoColor: 'none',
  },
};

export const getToken = (): string | null => {
  const token = localStorage.getItem(`@${authTitle}:token`);
  return token;
};
